export default {
  TRANSITION_TIMEOUT: 250,
};



// WEBPACK FOOTER //
// ./src/constants/transition-config-types.js